import React from "react";
import { TCText } from "../../../components/tcText/TCText";
import { Colors } from "../../../utils/colors";
import { PlayerDetails as Detail } from "../../../apis/types";
import { UserAvatar } from "../../../components/userAvatar/UserAvatar";

type props = {
  player?: Detail;
  team?: "A" | "B";
  isScoreAdded?: boolean;
};

export const PlayerDetails: React.FC<props> = ({
  player,
  team,
  isScoreAdded,
}) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flex: 1,
        marginTop: 5,
      }}>
      <UserAvatar
        avatar={{
          image: player?.playerImageUrl ?? "",
          name: player?.playerName ?? "",
        }}
        size={32}
        style={{ marginRight: 8 }}
      />
      <div style={{ flex: 1 }}>
        <TCText
          value={player?.playerName ?? ""}
          // numberOfLines={1}
          style={{
            fontSize: 10,
            fontWeight: 500,
            color: Colors.grey,
            //   overflow: "hidden",
            //   textOverflow: "ellipsis",
          }}
        />
        {isScoreAdded ? null : (
          <TCText
            value={`(Team-${team})`}
            // numberOfLines={1}
            style={{
              fontSize: 10,
              fontWeight: 500,
              color: Colors.grey,
              //   overflow: "hidden",
              //   textOverflow: "ellipsis",
            }}
          />
        )}
      </div>
      <TCText
        value={player?.phoneNumber ? player.phoneNumber : "N/A"}
        // numberOfLines={1}
        style={{
          fontSize: 10,
          fontWeight: 500,
          color: Colors.grey,
          //   overflow: "hidden",
          //   textOverflow: "ellipsis",
          flex: 1,
          textAlign: "center",
        }}
      />
      <TCText
        value={`App Installed: ${player?.isAppInstalled ? "✔️" : "❌"}`}
        // numberOfLines={1}
        style={{
          fontSize: 10,
          fontWeight: 500,
          color: Colors.grey,
          //   overflow: "hidden",
          //   textOverflow: "ellipsis",
          flex: 1,
          textAlign: "center",
        }}
      />
    </div>
  );
};
